import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { PaymentReportService } from '../../../../domain/services/payment-report/payment-report.service';
import { PaymentDto } from '../../../../domain/models/payment.model';
import { StatusIndicatorComponent } from '../../../../common/status-indicator/status-indicator.component';

@Component({
  selector: 'app-receipt-search',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatIconModule, MatButtonModule,
    MatInputModule, MatSelectModule, MatTableModule, MatPaginatorModule, MatTooltipModule,
    RouterLink, StatusIndicatorComponent],
  templateUrl: './receipt-search.component.html',
  styleUrl: './receipt-search.component.css'
})
export class ReceiptSearchComponent implements OnInit {
  displayedColumns = ['receiptNumber', 'paymentDate', 'accountName', 'totalPayment', 'status'];
  payments: PaymentDto[] = [];
  totalElements = 0;
  pageIndex = 0;
  pageSize = 10;
  query = '';
  queryStatus = '';
  statuses = ['COMPLETED', 'PENDING', 'REFUNDED', 'CANCELLED'];

  private readonly queryChanged = new Subject<void>();

  constructor(private readonly service: PaymentReportService) { }

  ngOnInit(): void {
    this.queryChanged.pipe(debounceTime(300)).subscribe(() => this.load());
    this.load();
  }

  onQueryChange() {
    this.pageIndex = 0;
    this.queryChanged.next();
  }

  onFilter() {
    this.pageIndex = 0;
    this.load();
  }

  onPage(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.load();
  }

  clearSearch() {
    this.query = '';
    this.onFilter();
  }

  load() {
    const q = this.query.trim();
    if (q.length > 0 && q.length < 3) return;
    this.service.searchPayments({
      // receipt numbers are all digits (yyyyMMdd + sequence); anything else is a customer name
      receiptNumber: /^\d+$/.test(q) ? q : undefined,
      customerName: q && !/^\d+$/.test(q) ? q : undefined,
      statuses: this.queryStatus ? [this.queryStatus] : undefined,
      page: this.pageIndex,
      size: this.pageSize
    }).subscribe(page => {
      this.payments = page.content ?? [];
      this.totalElements = page.totalElements ?? 0;
    });
  }
}
